export default {
  visual: {
    label: 'ORCA — your personal market intelligence system',
    logoAlt: 'ORCA',
    eyebrow: 'MARKET INTELLIGENCE',
    slogan: 'Less noise. More clarity.',
    domains: 'Crypto · Stocks · Macro · Orca AI',
  },
  language: { label: 'Language', ru: 'RU', en: 'EN', de: 'DE' },
  preloader: 'Analyzing the market…',
  loading: 'Loading',
  checking: { title: 'Opening ORCA', text: 'Checking your secure session…' },
  offline: { title: 'No connection', text: 'Check your internet connection and try again.' },
  error: {
    title: 'ORCA is temporarily unavailable',
    email: 'Enter a valid email address.',
    code: 'Enter the six-digit code.',
    codeExpired: 'This code has expired. Request a new one.',
    invalidCode: 'The code is incorrect or has expired.',
    provider: 'We could not verify this sign-in. Please try again.',
    expiredFlow: 'This sign-in has expired. Start again.',
    expiredLink: 'This link is invalid or has expired.',
    rateLimited: 'Too many attempts. Please try again later.',
    offline: 'No connection. Check your internet connection.',
    service: 'The service is temporarily unavailable. Please try again later.',
    generic: 'Something went wrong. Please try again.',
  },
  action: {
    google: 'Continue with Google',
    email: 'Continue with Email',
    telegram: 'Connect with Telegram',
    continue: 'Continue',
    verify: 'Verify',
    back: 'Back',
    cancel: 'Cancel',
    tryAgain: 'Try again',
    checkAgain: 'Check again',
    continueApp: 'Continue to ORCA',
    backToSignIn: 'Back to sign in',
  },
  welcome: {
    eyebrow: 'WEB ORCA',
    title: 'Sign in to ORCA',
    text: 'Markets, your assets and Orca AI in one account. No password: sign in with Google or a code sent to your email.',
    or: 'or',
    legal: 'By continuing, you acknowledge that ORCA is an information and analytics service.',
  },
  session: { expired: 'Your session has ended. Sign in again to continue.' },
  telegram: {
    offerTitle: 'Already using ORCA in Telegram?',
    offerText: 'Connect your Plus, Premium or active Trial from Telegram — no second payment.',
    notFoundTitle: 'ORCA account not found in Telegram',
    notFoundText: 'If you are new to ORCA, sign up with Email or Google.',
    paidTitle: 'No active subscription found',
    paidText: 'Telegram connection is available with Plus, Premium or an active Trial. To start using Web ORCA, sign up with Email or Google.',
    openBot: 'Open ORCA in Telegram',
  },
  email: {
    eyebrow: 'EMAIL',
    title: 'Sign in with email',
    text: 'We will send a one-time code. No password needed.',
    requiredEyebrow: 'ONE MORE STEP',
    requiredTitle: 'Add your email',
    requiredText: 'You will need it for sign-in and account security. This step cannot be skipped.',
    googleVerification: 'Confirm your current email with a one-time code.',
    label: 'Email',
    placeholder: 'name@example.com',
  },
  otp: {
    eyebrow: 'VERIFICATION',
    title: 'Enter the code',
    text: 'We sent a six-digit code to {{email}}.',
    label: 'Code from the email',
    help: 'The code is valid for 10 minutes.',
    expired: 'The code has expired. Request a new one.',
    resend: 'Send another code',
    resendIn: 'Send again in {{seconds}}s',
    changeEmail: 'Change email',
  },
  link: {
    eyebrow: 'ACCOUNT CONNECTION',
    title: 'This email is already used in Web ORCA',
    text: 'You already have a separate Web account. You can combine it with your ORCA subscription in Telegram.',
    keepTitle: 'After you continue, ORCA will keep:',
    keepPlan: 'your Telegram Plus, Premium or Trial',
    keepSettings: 'the paid account’s settings and data',
    keepSchedule: 'its subscription and schedule',
    webFree: 'The separate Web Free account will be combined with it.',
    confirm: 'Combine accounts',
    checking: 'Checking confirmation and account eligibility…',
    waitTitle: 'Confirm the connection in Telegram',
    waitText: 'Open the Telegram link, confirm your account, then return here.',
    expiredTitle: 'This link is no longer valid',
    expiredText: 'Request a new link and start the connection again.',
  },
  blocked: {
    title: 'These accounts cannot be combined now',
    text: 'The current access on both accounts or an existing connection prevents a safe combination. Nothing was changed.',
  },
  conflict: {
    title: 'The accounts were not combined',
    text: 'This sign-in method is already connected to another ORCA account. Use Email or contact support.',
  },
};
